import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PARAM_PATHS } from '../../navigation/paths.ts'
import { numericIdParam } from '../params.ts'
import { rootRoute } from '../root.tsx'

const requestIdParam = numericIdParam('requestId')

export const officialRequestRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PARAM_PATHS.officialRequest,
  params: requestIdParam,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/request.tsx')),
})

/** One request as a link target: `params` typed, so no page respells the path. */
export function officialRequestLink(requestId: number) {
  return { to: '/me/official/requests/$requestId', params: { requestId } } as const
}
